import React, { useState, useEffect, useRef } from "react";

const CareerSkillsSection = ({
  title = "TECH-READY SKILLS? CHECK.",
  subtitleLine = true,
  paragraphs = [
    `In Information Technology at JRIIT, you’ll get an education built on 10 core programs, which are vital for success in today’s digital age — technical expertise in coding, networking, cybersecurity, and more. These are the skills that employers say make JRIIT IT graduates stand out. Our Information Technology program offers both a 1-year Certificate for foundational skills and a 2-year Diploma for advanced specialization in cutting-edge technologies.`,

    `Why? We emphasize hands-on learning instead of traditional letter grades. In every course, you’ll receive detailed feedback on your technical strengths and where you can improve, giving you a more complete picture of your growth.`,

    `Discover our IT programs below and unlock the skills to shape your future.`,
  ],
}) => {
  const [visibleElements, setVisibleElements] = useState({});
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(
            () => setVisibleElements((prev) => ({ ...prev, title: true })),
            100,
          );
          setTimeout(
            () => setVisibleElements((prev) => ({ ...prev, content: true })),
            400,
          );
        }
      },
      { threshold: 0.1 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-16 md:py-24 lg:py-32 bg-gradient-to-br from-gray-50 via-white to-gray-100 overflow-hidden"
    >
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-10 w-80 h-80 bg-custom-pink/10 rounded-full blur-3xl animate-float" />
        <div className="absolute bottom-32 left-20 w-96 h-96 bg-gold/10 rounded-full blur-3xl animate-float-delayed" />
      </div>

      {/* Decorative Pattern */}
      <div className="absolute inset-0 bg-net-pattern opacity-3" />

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Title */}
        <div
          className={`text-center mb-2 transform transition-all duration-1000 ${visibleElements.title
              ? "translate-y-0 opacity-100"
              : "translate-y-10 opacity-0"
            }`}
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-custom-pink leading-tight">
            {title}
          </h2>
          {subtitleLine && (
            <div className="w-32 h-1 bg-gold mx-auto rounded-full mt-4" />
          )}
        </div>

        {/* Main Content */}
        <div
          className={`transform transition-all duration-1000 delay-300 ${visibleElements.content
              ? "translate-y-0 opacity-100"
              : "translate-y-10 opacity-0"
            }`}
        >
          <div className="bg-white/70 backdrop-blur-sm p-8 md:p-12 lg:p-16">
            <div className="text-left max-w-7xl mx-auto">
              {paragraphs.map((para, i) => (
                <p
                  key={i}
                  className="text-base md:text-lg lg:text-xl text-black leading-loose tracking-wide mb-8"
                >
                  {para}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Custom Animations */}
      <style>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px) translateX(0px);
          }
          33% {
            transform: translateY(-15px) translateX(10px);
          }
          66% {
            transform: translateY(10px) translateX(-10px);
          }
        }

        @keyframes floatDelayed {
          0%,
          100% {
            transform: translateY(0px) translateX(0px);
          }
          33% {
            transform: translateY(20px) translateX(-15px);
          }
          66% {
            transform: translateY(-10px) translateX(15px);
          }
        }

        .animate-float {
          animation: float 10s ease-in-out infinite;
        }

        .animate-float-delayed {
          animation: floatDelayed 12s ease-in-out infinite 3s;
        }
      `}</style>
    </section>
  );
};

export default CareerSkillsSection;
